<template>
<div  class="container-fluid">

  <div class="row">  
  <div class="col-md-4">  
  <div class="card border-primary">
  
    <h4 class="card-header text-white bg-primary"> 
      <i style="color:yellow" class="fas fa-cash-register mr-2" aria-hidden="true">
      </i>TOTALI CASSA </h4>      
  

  <div  class="card-body"> 

 <div v-if="type=='A'">  
<!--<form v-on:submit.prevent="getData()">-->
  <div class="row">

 <div class="col-md-6">
  <div class="form-group">
    <label for="exampleInputDataVendita"><strong>DATA VENDITA</strong></label>
    <input :disabled="isAdmin==0 && company.Id==28" v-focus type="date"  class="form-control " id="create_at"  v-model="create_at">    
  </div>
</div>
<div class="col-md-6">

  <div class="form-group">
    <label for="exampleInputCassa"><strong>CASSA</strong></label>
    <cassa  @setDesk="setDeskId"/>
  </div>

    
  </div>
  
   </div> 

   <button @click="getData($event)" class="btn btn-primary mb-1 ml-2">
      <i style="color:white" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      CERCA
       <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>
  <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<!--</form>-->

</div>
<div v-else>

  <span>
    CASSA <strong>{{ deskId }}</strong>  
  </span>

  <span>
    DEL <strong> {{ getReverseDate(create_at) }}</strong>
  </span>
  
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table table-bordered table-sm table-striped mb-0">
    <thead>
      <tr class="table-primary">
        
        <th scope="col">TIPO PAGAMENTO</th>
        <th class="text-right" scope="col">IMPORTO €</th>
        
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td>{{item.typeId}}</td>
        <td class="text-right">{{fmt1(item.total)}}</td>
               
      </tr> 
    </tbody>
        <tfoot class="total">
        <tr style="background-color:green ;color:white">
          <th class="text-left">TOTALE</th>
          <th class="text-right">€ {{fmt1(total)}}</th>
          
        </tr>
      </tfoot> 
  </table>

  </div>

<table class="table table-sm table-bordered table-striped ">
  <thead class="unionAll" >
    <tr class="table-light">
      
      <th scope="col">TIPO OPERAZIONE</th>
      <th class="text-right" scope="col">IMPORTO €</th>
      
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in operations" :key="index">
      <td>{{item.typeId}}</td>
      <td class="text-right">{{fmt1(item.total)}}</td>
             
    </tr> 
  </tbody>
      
</table>

<button  @click="type='A'"  class="btn btn-secondary float- mt-2 ml-2">
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
    RITORNA A PARAMETRI RICERCA
       
  </button>

  <EpsonDailyClosure v-bind:data="fiscalPrinter" v-if="fiscalPrinter.show == 1" @close="hideDailyClosure()"></EpsonDailyClosure>

  <button v-if="fiscalPrinter.fpId==1" @click="showDailyClosure()"  class="btn btn-success float-right mt-2 mr-4">
    <i style="color : blue" class="fas fa-cash-register mr-2" aria-hidden="true"></i>
    CHIUSURA FISCALE GIORNALIERA
       
  </button>
  <button :disabled="items.length==0" @click="printPayments()"  class="btn btn-primary float-right mt-2 ml-4 mr-4">
    <i style="color :white" class="fas fa-print mr-2" aria-hidden="true"></i>
    STAMPA
       
  </button>
 
</div>
</div>

</div>

</div>
</div>
</div>

</template>
<script>
//import axios             from "axios";
import api               from '@/api';
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import cassa             from '@/components/common/Desk.vue';
import pushState         from '@/components/mixins/pushState'
import JSPM              from 'jsprintmanager'
import receiptHF         from '@/components/mixins/ReceiptHeading.js'
import fmt               from '@/components/mixins/fmt.js'
import EpsonDailyClosure from '@/components/rt/EpsonDailyClosure.vue'



JSPM.JSPrintManager.auto_reconnect = true;
JSPM.JSPrintManager.start();

export default {
  mixins : [pushState,receiptHF,fmt],
  components: {alertBox,cassa,EpsonDailyClosure},
  data() {
    return {
    
      create_at              : new Date().toISOString().slice(0, 10),
      bt_spinner             : false,
      
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      },
      items                  : [],
      deskId                 : 1,
     
      
      operations             : [],
      //HF_Rows                : [],
      type                   : 'A',
      fiscalPrinter          : {}
    
    
      
    };
  },
  computed :{
    ...mapGetters(['company','storeId','isAdmin']),

   total : function() {
   
      var total = 0
      this.items.forEach(item => {
        total += item.total 
      })

      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    
    //this.getHF_Rows()

  },
  created: function() {

    this.getFiscalPrinter()
  },
  methods: {
    showDailyClosure()
    {
      this.fiscalPrinter.show = 1
    },
    hideDailyClosure()
    {
      this.fiscalPrinter.show = 0
    },
    
   async getFiscalPrinter()
   {
    
    this.fiscalPrinter = {}
    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId':this.storeId,'deskId':this.deskId}      
    const json  = Object.assign(data, sp)
      
      //this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            this.fiscalPrinter = res.data.recordsets[0][0]
            
         }
         console.log('FISCAL PRINTER ',this.fiscalPrinter)
        }
        else if(res.status==500)
        {
         
     
        
        } 
        else
        {
          
        
        } 
    }).catch(err => 
    {
      
     
       
    }).finally(() => {
      
    });

  

   }, 
   getReverseDate(data) 
   {
     
     const d = data.substring(8,10)
     const m = data.substring(5,7)
     const y = data.substring(0,4)
     
     return d + '/' +  m + '/' + y

   },

   async getHFRows()
   {
      const data = await this.getReceiptHeading(this.storeId,this.deskId)
      return data
   }, 
   setDeskId(deskId)
   {     
     this.deskId = deskId
     this.getFiscalPrinter()
     //this.getHF_Rows()
   },

  async printPayments()
   {
       
       const receiptText = await this.getHFRows()
    
       function jspmWSStatus() {
          if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
              return true;
          else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
              alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
              return false;
          }
          else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
              alert('JSPM has blocked this website!');
              return false;
          }
      }
      


      const pad        = ' '  
      const GS         = '\x1d'  
      const esc        = '\x1B'; //ESC byte in hex notation
      const newLine    = '\x0A'; //LF byte in hex notation
  
      let cmds         = esc + "@"; //Initializes the printer (ESC @)
      let cols         = 42
      
      //cmds += newLine  
      const header = receiptText.filter(item => item.type == 'H')
      //const footer = receiptText.filter(item => item.type == 'F')

      // HEADER 
      header.forEach(row =>{
        
          if(row.order_by == 1)
          {   
              cols = row.cols   
              
              

              cmds += esc + 'a' + '\x01'
              cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
              cmds += row.text  //text to print
              cmds += newLine;
              
          }
          else
          {
             // cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
             // cmds += row.text  //text to print
             // cmds += newLine;
          }
          
        
  
      })
      
      
      cmds += newLine   
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)   
      cmds += 'RIEPILOGO OPERAZIONI CASSA ' + this.items[0].deskId   //text to print 
      cmds += newLine
      
      cmds += this.items[0].store + ' del ' + this.items[0].create_at   //text to print                
      cmds += newLine
      
      let spc = cols - 18        
      cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
      
      cmds += newLine
      cmds += 'TIPO PAGAMENTO' + pad.repeat(spc) + 'EURO'   //text to print          
      cmds += newLine      
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
          
      // BODY
      this.items.forEach(item => {
            
            //let price = this.fmt1(item.new_cb)
            let price   = this.fmt1(item.total)
            let product =  item.typeId
            spc         = cols - product.length - price.length            
            cmds        += product + pad.repeat(spc) +  price   //text to print             
            cmds        += newLine;                    
          
      })
      
      cmds += newLine;
      spc = cols - 6 - this.fmt1(this.total).length   
      cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
      cmds += 'TOTALE' + pad.repeat(spc) + this.fmt1(this.total)   //text to print    
      
      cmds += newLine
      cmds += newLine
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)   
      cmds += 'RIEPILOGO OPERAZIONI'    //text to print    
      cmds += newLine
      

      this.operations.forEach(item => {
            
           
            let price   = this.fmt1(item.total)
            let product =  item.typeId
            spc         = cols - product.length - price.length            
            cmds        += product + pad.repeat(spc) +  price   //text to print             
            cmds        += newLine;                    
          
      })
     
      cmds += newLine
      cmds += newLine
     
      
      

      
      cmds += esc + 'a' + '\x01'
      cmds += esc + '!' + '\x38'; 
      
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            
      cmds += newLine
      cmds += newLine
      
      

 
      
      cmds += newLine
      cmds += newLine
      cmds += newLine
      cmds += newLine
      
      cmds += GS + 'V' + '\x01'   
      cmds += newLine
      
    
      if (jspmWSStatus()) {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              cpj.clientPrinter = new JSPM.DefaultPrinter();
                           
              cpj.printerCommands = cmds;
              //Send print job to printer!
              cpj.sendToClient();

      }
   },

 
    async getData(evt) {
      
      //console.log(evt)
            
      this.items = []
      this.operations = []
      
      this.msg.title = ''

      if(!this.create_at)
      {
        
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = 'Data di vendita non valida.'
        this.msg.type  = 1
        return
      }
      
      const sp    = {'sp':'spStorePaymentsUnionAll'}
      
      let printed1 = 0
      let printed2 = 1

      if(this.company.Id == 48 )
      {
        printed1 = 1
        printed2 = 1
        
      }
      if(this.company.Id == 48 && evt.ctrlKey)
      {
        printed1 = 0
        printed2 = 0
        
      }
      if(this.company.Id == 48 && evt.shiftKey)
      {
        printed1 = 0
        printed2 = 1
        
      }

      
      const data  = {'storeId':this.storeId,'create_at':this.create_at,'deskId':this.deskId,'printed1':printed1,'printed2':printed2}      
      const json  = Object.assign(data, sp)
      
      this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
          this.items    = res.data.recordsets[0]
          this.operations = res.data.recordsets[1]
          
          if(this.items.length==0 && this.operations.length == 0)
          {
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = 'DATI INESISTENTI.'
            this.msg.type  = 1
            return
          } 
          this.type = 'B'        
        }
        else if(res.status==500)
        {
         
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res.data
          this.msg.type  = 1
        } 
        else
        {
          
          
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res
          this.msg.type  = 1                  

        } 
    }).catch(err => 
    {
      
     
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1       
       
    }).finally(() => {
      this.bt_spinner = false
    });


    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 200px;
overflow: auto;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .table .unionAll tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : white;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


h4,p {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.total
{
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.card-header
{
  height: 45px;
}
</style>